export default __webpack_public_path__ + "static/media/TheRecharge_Neoncar00687.b452ecd9.png";